'use strict';

$(function () {
    $('.js-bildspel').each(function (index) {
        $(this).data('index', index);
    });

    $(document).on('click', '.js-bildspel', function () {
        const pswpElement = document.querySelector('.pswp');

        let items = [];

        $('.js-bildspel-bildurl').each(function () {
            let title = '';
            if ($(this).siblings('[data-title]').length > 0) {
                title = $(this).siblings('[data-title]')[0].innerHTML;
            }

            let item = {};
            item.src = $(this).val();
            item.title = title;
            item.w = $(this).data('width');
            item.h = $(this).data('height');
            items.push(item);
        });

        const options = {
            index: $(this).data('index')
        };

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    });
});



